import { Box, ListItemIcon, ListItemText, Paper, SpeedDial, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Box)(() => ({
  position: "relative",
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "flex-end",
  width: 40,
  height: 40,
}));

export const CaptionsButtonContainer = styled(Box)(() => ({
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const CaptionsButton = styled(SpeedDial)(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "40px",
  top: "-8px",
  "& .MuiSpeedDial-fab": {
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  "& .MuiSpeedDial-fab:hover": {
    backgroundColor: "transparent",
  },
  "& .MuiButtonBase-root": {
    width: 40,
    height: 40,
    padding: 0,
    margin: 0,
  },
  "& .MuiSpeedDialAction-fab": {
    marginTop: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  "& .MuiSvgIcon-root": {},
}));

export const ButtonActionsContainer = styled("div")(({ theme }) => ({
  position: "absolute",
  zIndex: 9999,
  bottom: "60px",
  right: "-120px",
  [theme.breakpoints.down("md")]: {
    bottom: "40px",
  },
  [theme.breakpoints.down("sm")]: {
    bottom: "40px",
  },
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  maxWidth: "100%",
  minWidth: "320px",
  background: theme.palette.grey[800],
  opacity: "90%",
  borderRadius: "0px",
  [theme.breakpoints.down("sm")]: {
    height: "auto",
    maxHeight: "240px",
    overflowY: "auto",
  },
  [".MuiList-root"]: {
    textAlign: "left",
    padding: "0px",
    ["& li"]: {
      padding: "10px 16px",
      [theme.breakpoints.down("sm")]: {
        padding: "0px 12px",
      },
    },
  },
}));

export const StyledListItemIcon = styled(ListItemIcon)({
  color: "white",
  minWidth: "25px",
  ["svg"]: {
    fontSize: "1.25rem",
  },
});

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  paddingRight: "8px",
  color: "white",
  textAlign: "left",
  [theme.breakpoints.down("sm")]: {
    paddingRight: "15px",
  },
  ["span"]: {
    fontSize: "0.875rem",
    fontWeight: 600,

    [theme.breakpoints.down("md")]: {
      fontSize: "0.75rem",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "0.75rem",
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: 1.4,
    },
  },
}));

export const StyledTypography = styled(Typography)({
  color: "white",
  ["svg"]: {
    fontSize: "0.875rem",
  },
});
